export default ({store, app: { $axios }}) => {
  $axios.setToken(localStorage.getItem('api_token'), 'Bearer');
}
